export default class Font {
  constructor(fontFamily = 'Arial', fontSize = 45, fontColor = '#000', isBold = false, isItalic = false, isUnderline = false) {
    this.fontFamily = fontFamily;
    this.fontSize = fontSize;
    this.fontColor = fontColor;
    this.isBold = isBold;
    this.isItalic = isItalic;
    this.isUnderline = isUnderline;
  }

  toCss() {
    const style = {
      fontSize: this.fontSize,
      fontFamily: this.fontFamily,
      color: this.fontColor,
      fontWeight: this.isBold ? 600 : 400
    };

    if (this.isItalic) {
      style.fontStyle = 'italic';
    }

    if (this.isUnderline) {
      style.textDecoration = 'underline';
    }

    return style;
  }

}
